import React, { Component } from 'react';
import { TouchableOpacity } from 'react-native';

import styles from './styles';
import Colors from '../../config/Colors';

export default class zbuttonBack extends Component {
    render() {
        const { Icon } = this.props;

        return (
            <TouchableOpacity style={styles.iconBack} onPress={this.handleBack}>
                <Icon sx={{
                    color: Colors.secondary,
                    fontSize: 28
                  }}
                />
            </TouchableOpacity>
        );
    }

    handleBack = () => {
        const { returnCallback } = this.props;

        if (returnCallback) {
            returnCallback();
        } else {
            this.props.navigation.goBack();
        }
    };
}
